<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />
    <site-device-query :options="filterSites" :query="query" />
    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="dataList"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="日期" prop="dataTime" align="center" />
        <el-table-column label="站点" prop="siteName" />
        <el-table-column label="设备" prop="deviceName" />
        <el-table-column label="因子" prop="factorName" />
        <el-table-column label="监测值" prop="value">
          <template slot-scope="{row}">{{row.value}} {{row.unit}}</template>
        </el-table-column>
        <el-table-column label="超标范围">
          <template slot-scope="{row}">{{row.alarmMin}}~{{row.alarmMax}} {{row.unit}}</template>
        </el-table-column>
        <!--      <el-table-column label="数采标记">-->
        <!--        <template slot-scope="{row}">{{dasFlagMap[row.dasFlag] ? `${dasFlagMap[row.dasFlag].name},${dasFlagMap[row.dasFlag].name.charCodeAt(0) >= 97 ? '无' : '有'}效` : ''}}</template>-->
        <!--      </el-table-column>-->
        <!--      <el-table-column label="机审标记">-->
        <!--        <template slot-scope="{row}">{{auditRuleMap[row.autoFlag] ? auditRuleMap[row.autoFlag].name : ''}}</template>-->
        <!--      </el-table-column>-->
      </el-table>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseDateData from '../../../BaseDateData'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'OperationsFactorAlarm',
  routeInfo: {
    label: '因子超标报警',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {DataWrapper},
  data () {
    return {
      query: {
        siteDeviceIds: []
      },
      currentQuery: Object.freeze({}),
      auditRuleMap: Object.freeze({}),
      dataList: []
    }
  },
  computed: {
    dasFlagMap: () => ({
      N: {
        name: '正常'
      },
      D: {
        name: '数据不足'
      },
      B: {
        name: '仪器故障'
      },
      C: {
        name: '仪器校准'
      },
      P: {
        name: '站房停电'
      },
      H: {
        name: '超量程上限'
      },
      L: {
        name: '超量程下限'
      },
      M: {
        name: '仪器维护'
      }
    }),
    queryTimeStep: () => 1,
    endTimeDiff: () => 0,
    filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {profileSites} = this

      if (profileSites.length === 0) {
        return []
      }

      let siteDeviceMap = profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      return Object.values(profileSites.reduce((map, site) => {
        let siteId = site.id

        if (siteDeviceMap.hasOwnProperty(siteId)) {
          map[siteId] = {
            value: siteId,
            label: site.name,
            children: siteDeviceMap[siteId].map(siteDevice => ({
              value: siteDevice.id,
              label: siteDevice.name
            }))
          }
        }

        return map
      }, {}))
    },
    canNotSearch () {
      return this.query.siteDeviceIds.length === 0
    }
  },
  methods: {
    setSiteDeviceIds (sites) {
      if (sites.length > 0) {
        let {query} = this

        if (query.siteDeviceIds.length === 0) {
          query.siteDeviceIds = sites[0].children.map(siteDevice => siteDevice.value)
        }

        setTimeout(() => {
          this.search()
        }, 0)
      }
    },
    search () {
      this.setCurrentQuery()
      this.getData()
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      let {currentQuery} = this
      this.changeLoadStatus(true)
      this.$api.OperationsAlarm.getList({
        beginTime: currentQuery.beginTime,
        endTime: currentQuery.endTime,
        siteDeviceIds: currentQuery.siteDeviceIds
      }).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      let {factorMap} = this

      dataList.forEach(data => {
        let factor = factorMap[data.factorId]
        data.factorName = factor.name
        data.unit = factor.stdUnit
        data.ts = new Date(data.dataTime).getTime()
      })

      dataList.sort((a, b) => a.ts - b.ts)

      this.dataList = dataList
    },
    onSearchBtnClick () {
      this.search()
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (newVal) {
        this.setSiteDeviceIds(newVal)
      }
    }
  },
  created () {
    this.$api.AuditRuleCategory.getList().then(auditRules => {
      this.auditRuleMap = Object.freeze(auditRules.reduce((map, auditRule) => auditRule.flags.reduce((map, flag) => {
        map[flag] = {
          id: auditRule.id,
          name: auditRule.name.replace(/规则$/, '')
        }
        return map
      }, map), {}))
    }).catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/06Alarm/01FactorExcessive/index.vue